<div class="loader-container" *ngIf="visible">
  <div class="loader-animation">
    <div class="loader-item"></div>
  </div>
  <span *ngIf="info" class="loader-info">{{ info | translate }}</span>
</div>
